import { render, staticRenderFns } from "./CollectionGroup.vue?vue&type=template&id=713d60bd"
import script from "./CollectionGroup.vue?vue&type=script&lang=js"
export * from "./CollectionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports